import React, { useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import LeafletMapping from './LeafletMapping';

function LeafletHistory({ fguid, vehicle }) {
    const [startDate, setStartDate] = useState('2025-04-15T10:00');
    const [endDate, setEndDate] = useState('2025-05-15T15:59');
    const [rawData, setRawData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [interval, setInterval] = useState('all');

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post('https://icloud.assetscontrols.com:3443/OpenApi/LBS', {
                FAction: 'QueryLBSTrackListByFGUID',
                FTokenID: '3585535a-137c-499e-82ad-af9feff7d8e7',
                FGUID: fguid,
                FType: '2',
                FStartTime: startDate.replace('T', ' ') + ':00',
                FEndTime: endDate.replace('T', ' ') + ':59',
                FAssetTypeID: '400',
                FLanguage: '0',
                FDateType: 0
            });

            if (response.data?.Result === 200) {
                setRawData(response.data.FObject);
                filterByInterval(interval, response.data.FObject);
            } else {
                alert('Error: ' + response.data.Message);
            }
        } catch (error) {
            console.error('Request failed', error);
            alert('Failed to fetch data');
        }
        setLoading(false);
    };

    const filterByInterval = (type, dataSource = rawData) => {
        setInterval(type);

        if (type === 'all') {
            setFilteredData(dataSource);
            return;
        }

        const grouped = {};

        dataSource.forEach((item) => {
            const time = dayjs(item.GT);
            let key;

            switch (type) {
                case 'day':
                    key = time.format('YYYY-MM-DD');
                    break;
                case 'hour':
                    key = time.format('YYYY-MM-DD HH');
                    break;
                case 'minute':
                    key = time.format('YYYY-MM-DD HH:mm');
                    break;
                case '15s':
                    key = time.format('YYYY-MM-DD HH:mm:ss').slice(0, 17);
                    break;
                default:
                    key = 'all';
            }

            if (!grouped[key]) {
                grouped[key] = {
                    count: 0,
                    sumFV1: 0,
                    example: item
                };
            }

            grouped[key].sumFV1 += parseFloat(item.FV1) || 0;
            grouped[key].count += 1;
        });

        const averagedData = Object.values(grouped).map(group => ({
            ...group.example,
            FV1: (group.sumFV1 / group.count).toFixed(2)
        }));

        setFilteredData(averagedData);
    };

    return (
        <div className="p-4 space-y-4">
            <div className="flex flex-col sm:flex-row gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Start Date:</label>
                    <input 
                        type="datetime-local" 
                        value={startDate} 
                        onChange={e => setStartDate(e.target.value)} 
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">End Date:</label>
                    <input 
                        type="datetime-local" 
                        value={endDate} 
                        onChange={e => setEndDate(e.target.value)} 
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                    />
                </div>
                <div className="flex items-end">
                    <button 
                        onClick={fetchData} 
                        disabled={loading}
                        className="moButtons text-white px-4 py-2 rounded disabled:opacity-50"
                    >
                        {loading ? 'Loading...' : 'Fetch Data'}
                    </button>
                </div>
            </div>

            <div className="flex gap-2 flex-wrap">
                {['all', 'day', 'hour', 'minute', '15s'].map((intv) => (
                    <button
                        key={intv}
                        onClick={() => filterByInterval(intv)}
                        className={`moButtons px-3 py-1 border rounded text-sm ${
                            interval === intv 
                                ? 'bg-blue-600 text-white border-blue-600' 
                                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                        {intv}
                    </button>
                ))}
            </div>

            <div className="text-lg font-medium">
                Vehicle Tracking: {vehicle}
            </div>

            {filteredData.length === 0 ? (
                <div className="text-center text-gray-500 mt-8 text-xl py-12 bg-gray-50 rounded-lg">
                    {loading ? 'Loading data...' : 'No tracking data to display. Please fetch data first.'}
                </div>
            ) : (
                <div className="mt-4">
                    <LeafletMapping
                        data={filteredData} 
                        vehicleName={vehicle}
                    />
                </div>
            )}
        </div>
    );
}

export default LeafletHistory;